import { Typography } from '@pvh-components/typography';
import { ReactComponentElement } from 'react';
import { WithTestId } from '../../types';
import { toKebabCase } from '../../utils/casing';
import Icon from '../Icon/Icon';
import styles from './benefitsGrid.module.css';

export interface Benefit {
  Icon: ReactComponentElement<typeof Icon>;
  title: string;
}

export interface BenefitsGridProps extends WithTestId {
  benefits: Benefit[];
}

const BenefitsGrid = ({ benefits, dataTestIdPrefix }: BenefitsGridProps) => (
  <div
    className={styles.benefitsGrid}
    data-testid={toKebabCase(dataTestIdPrefix, 'benefitsGrid')}
  >
    {benefits.map((benefit: Benefit) => (
      <div
        key={benefit.title}
        data-testid={toKebabCase(
          dataTestIdPrefix,
          'benefitsGridItem',
          benefit.Icon.props.name
        )}
      >
        {benefit.Icon}
        <Typography variant="h4">{benefit.title}</Typography>
      </div>
    ))}
  </div>
);
export default BenefitsGrid;
